import request from '../../utils/request'

export function fetchList (data) {
  return request.post('/business/withdrawalOrders/page', data, {
    trim: true
  })
}

export function getById (id) {
  return request.get(`/business/withdrawalOrders/${id}`)
}

export function getTotalAmount (data) {
  return request.post('/business/withdrawalOrders/totalAmount', data, {
    trim: true
  })
}

export function audit (data) {
  return request.post('/business/withdrawalOrders/audit', data, {
    trim: true
  })
}

export function approve (data) {
  return request.post('/business/withdrawalOrders/approve', data, {
    trim: true
  })
}
